import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import Page from "../../components/general/page";
import ReportsHomePage from "../../components/report/home";
import { clearReportSearchData } from "../../store/actions/reports";

const ReportsHomeView = ( props ) => {
  const {pageRef} = props;

  const dispatch = useDispatch();
  const location = useLocation();
  /**
   * BEGIN TODO: da rimuovere postDemo. Per capire se voglio o meno header e sidebar
   */
  const embedParameter = new URLSearchParams(location.search).get("embed");
  /**
    * END TODO: da rimuovere postDemo
    */

  useEffect(() => {
    dispatch(clearReportSearchData());
  }, []);

  return (
    <Page
      pageRef={pageRef}      
      title={"REPORT"}      
      className={"contentStructure settings " + (embedParameter === "" ? "embed" : "")}
    >
      <ReportsHomePage />
    </Page>
  );
};

export default ReportsHomeView;
